import { render, staticRenderFns } from "./RemoveGroupModal.vue?vue&type=template&id=63646586&scoped=true&"
import script from "./RemoveGroupModal.vue?vue&type=script&lang=js&"
export * from "./RemoveGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGroupModal.vue?vue&type=style&index=0&id=63646586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63646586",
  null
  
)

export default component.exports